module.exports = __webpack_public_path__ + "static/media/PrideBlack.4cdc8263.jpeg";